import { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { feLoggingLogEvent, logLevels } from 'actions/log'
import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { useUserIdForOptimizely } from 'containers/OptimizelyRollouts/useOptimizely.hook'
import { useAuth } from 'routes/Menu/domains/auth'

export const useIsActionBarRedesignEnabled = (): boolean | null => {
  const { isAuthenticated } = useAuth()
  const featureValue = useIsOptimizelyFeatureEnabled(
    'beetroots_action_bar_redesign_prospects_web_enabled',
  )

  // this logging is added to have more information about Optimizely allocation issue
  // https://gousto.atlassian.net/browse/TG-7043
  const dispatch = useDispatch()
  const userIdForOptimizely = useUserIdForOptimizely()

  useEffect(() => {
    if (typeof featureValue !== 'boolean' || !userIdForOptimizely) return

    dispatch(
      feLoggingLogEvent(logLevels.info, 'optimizely_action_bar_redesign_v2', {
        userIdForOptimizely,
        isAuthenticated,
        featureValue,
      }),
    )
  }, [dispatch, featureValue, isAuthenticated, userIdForOptimizely])

  if (isAuthenticated) {
    return false
  }

  return featureValue
}
